export type StarfishDeviceState = {
    starfishgatewayLoading: boolean;
    starfishgatewaySuccess: boolean;
    loading: boolean;
    success: boolean;
    errorCode: string;
    hasData: boolean;
    connectionString: string;
    id: string;
    deleteGatewaySuccess: boolean;
    deleteGatewayMessage: string;
    deleteChildDeviceSuccess: boolean;
    deleteChildDeviceMessage: string;
};
export const initialStarfishDevice: StarfishDeviceState = {
    starfishgatewayLoading: false,
    starfishgatewaySuccess: false,
    loading: false,
    success: false,
    errorCode: '',
    hasData: true,
    connectionString: '',
    id: '',
    deleteGatewaySuccess: false,
    deleteGatewayMessage: "",
    deleteChildDeviceSuccess: false,
    deleteChildDeviceMessage: "",
};